import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";

export interface CardState {
  ccSeqId: any;
  ccType: any;
  dataMask: any;
}

const initialState: CardState = {
  ccSeqId: "",
  ccType: "",
  dataMask: "",
};

export const cardState = createSlice({
  name: "card",
  initialState,
  reducers: {
    setCard: (state, action: PayloadAction<CardState>) => {
      return action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.card;

export const selectCard = createSelector(selector, (s) => s);

export const { setCard } = cardState.actions;

export default cardState.reducer;
